import slide_1 from '../assets/slides/slide_1.png'
import slide_2 from '../assets/slides/slide_2.png'
import slide_3 from '../assets/slides/slide_3.png'
import slide_4 from '../assets/slides/slide_4.png'
import slide_5 from '../assets/slides/slide_5.png'
import slide_6 from '../assets/slides/slide_6.gif'
import slide_7 from '../assets/slides/slide_7.png'
import slide_8 from '../assets/slides/slide_8.png'

export const slideItems = [
  {
    name: 'Andrew Bartson smiling',
    img: slide_1,
    caption: 'Happy code warrior'
  },
  {
    name: 'Sockeye salmon with sharp teeth',
    img: slide_2,
    caption: 'Happy salmon, ready to spawn and die'
  },
  {
    name: 'Team of developers typing on laptops',
    img: slide_3,
    caption: 'Hack-a-thon! Bring on the pizza!'
  },
  {
    name: 'Boat harbor with houses and mountains',
    img: slide_4,
    caption: "View of Sitka, Alaska from the John O'Connell Bridge"
  },
  {
    name: 'Andrew Bartson in front of Maple leaves',
    img: slide_5,
    caption: 'If you want to launch big ships, you have to go where the water is deep'
  },
  {
    name: 'Red and orange clouds moving over vast desert',
    img: slide_6,
    caption: 'Sunrise over the badlands'
  },
  {
    name: 'Andrew Bartson on a beach in California',
    img: slide_7,
    caption: "I'm so glad I'm livin' in the USA"
  },
  {
    name: 'Two lane desert highway with Joshua trees',
    img: slide_8,
    caption: 'I got the key to highway'
  }
]
